import { Link } from "@mui/material";
import { parsePhoneSegments } from "src/components/common/dataGrid/cells/TextWithPhoneLinks.utils.ts";

export interface TextWithPhoneLinksProps {
	text: string | null | undefined;
}

export const TextWithPhoneLinks = ({ text }: TextWithPhoneLinksProps) => {
	if (text == null || text === "") return null;

	const segments = parsePhoneSegments(text);
	if (segments.length === 1 && segments[0]!.type === "text") return <>{text}</>;

	return (
		<>
			{segments.map((segment, i) =>
				segment.type === "phone" ?
					<Link key={i} href={`tel:${segment.href}`} underline="always" color="inherit">
						{segment.display}
					</Link>
				:	segment.display,
			)}
		</>
	);
};
